"use strict";

exports.__esModule = true;
exports.useFormField = useFormField;

var _react = require("react");

var _hooks = require("@bydesign-ui/hooks");

var _form = require("../../../models/form");

var _useForm = require("./useForm");

var _useFormScope = require("./useFormScope");

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function useFormField(options) {
  var form = (0, _useForm.useForm)();
  var scope = (0, _useFormScope.useFormScope)();

  var _useReactiveState = (0, _hooks.useReactiveState)(function () {
    return new _form.FormField(form, scope, options);
  }, options, function (ins) {
    return ins.getFieldInfo();
  }),
      instance = _useReactiveState[0],
      state = _useReactiveState[1];

  var onValueChange = (0, _react.useCallback)(function (value) {
    return instance.setValue(value);
  }, []);
  var onBlur = (0, _react.useCallback)(function () {
    return instance.validate('blur');
  }, []);
  var validate = (0, _react.useCallback)(function () {
    return instance.validate('manual');
  }, []);
  var domRef = (0, _react.useRef)(null);
  var inputRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    var callback = function callback() {
      var scrollToFirstError = form.getScrollToFirstError();

      if (scrollToFirstError) {
        if (inputRef.current != null) {
          var preventScroll = domRef.current != null;
          inputRef.current.focus({
            preventScroll: preventScroll
          });
        }

        if (domRef.current) {
          domRef.current.scrollIntoView({
            block: 'center',
            behavior: 'smooth'
          });
        }
      }
    };

    instance.addListener('focus', callback);
    return function () {
      return instance.removeListener('focus', callback);
    };
  }, []);
  return _extends({}, state, {
    instance: instance,
    onValueChange: onValueChange,
    onBlur: onBlur,
    validate: validate,
    domRef: domRef,
    inputRef: inputRef
  });
}